import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import './index.css'
import App from './App.jsx'

if (typeof window.gtag === "function") {
    window.gtag("config", import.meta.env.VITE_GA_MEASUREMENT_ID, {
        send_page_view: false,
    });
}

createRoot(document.getElementById('root')).render(
  <StrictMode>
    <App />
  </StrictMode>,
)
